import { Button, FlexBox, Text } from '@dixa/lib-shared-habla';

import styles from './appFallback.module.scss';

/**
 * A component that presents a fallback for when the app catches an error in the
 * error boundary.
 */
export const AppFallback = (): JSX.Element => {
  /** Handles reloading of the app. */
  const handleAppReload = () => {
    window.location.reload();
  };

  return (
    <FlexBox
      className={styles.root}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <Text.Heading className={styles.heading}>
        Something went wrong.
      </Text.Heading>
      <Button onClick={handleAppReload}>Try reloading</Button>
    </FlexBox>
  );
};
